import { useAutoAnimate as H } from "hooks-library";
import { UpDownButtons as b } from "./UpDownButtons/UpDownButtons.js";
import { CheckInput as v } from "./CheckInput/CheckInput.js";
import { classes as m } from "../classes/classes.js";
import '../assets/ControlPanelManager.css';const f = "op_holder_sLU1J", A = "op_controlHolder_yFFlO", C = "op_deactivated_weAfH", N = "op_headerHolder_mCctB", L = "op_title_wGkTP", k = "op_controlList_WSn8m", e = {
  holder: f,
  controlHolder: A,
  deactivated: C,
  headerHolder: N,
  title: L,
  controlList: k
};
function S(d) {
  let {
    settings: r,
    setSettings: c,
    olAttributes: a,
    liAttributes: l,
    holderAttributes: p = {},
    controlInputAttributes: u,
    controlLableAttributes: h,
    move: s = !0,
    controls: o = [
      { settingToChange: "use", label: "Show/hide", title: "click to show/hide" }
    ]
  } = d, [_] = H();
  return /* @__PURE__ */ React.createElement("div", { ...p }, /* @__PURE__ */ React.createElement("div", { className: e.headerHolder }, o ? /* @__PURE__ */ React.createElement("span", null, "Controls") : "", s ? /* @__PURE__ */ React.createElement("span", null, "Order") : ""), /* @__PURE__ */ React.createElement("ol", { ...a, ref: _, className: m(e.holder, a == null ? void 0 : a.className) }, r.map((E, i) => {
    let { id: n, use: R, name: g } = E;
    return /* @__PURE__ */ React.createElement("li", { key: n, key: n, ...l, className: m(e.controlHolder, R ? "" : e.deactivated, l == null ? void 0 : l.className) }, /* @__PURE__ */ React.createElement("div", { className: e.controlList }, o == null ? void 0 : o.map((t) => /* @__PURE__ */ React.createElement(
      v,
      {
        settings: r,
        setSettings: c,
        index: i,
        settingToChange: t.settingToChange,
        inputAttributes: {
          name: n,
          title: t == null ? void 0 : t.title,
          ...u
        },
        label: t.label,
        labelAttributes: h
      }
    ))), /* @__PURE__ */ React.createElement("span", { className: e.title }, g), s ? /* @__PURE__ */ React.createElement(b, { index: i, settings: r, setSettings: c }) : "");
  })));
}
export {
  S as ControlPanelManager
};
